import React from "react";
import Model from "@tripian/model";
import classes from "./VisaSteps.module.scss";

interface IVisaSteps {
  activeStep: 1 | 2;
  t: (value: Model.TranslationKey) => string;
}

const VisaSteps: React.FC<IVisaSteps> = ({ activeStep, t }) => (
  <div className={classes.steps}>
    <span
      className={`${classes.step} ${
        activeStep === 1 ? classes.active : classes.done
      }`}
    >
      <span className={classes.badge}>{activeStep === 1 ? "1" : "✓"}</span>
      {t("visa.auth.steps.createAccount")}
    </span>
    <span className={classes.connector} />
    <span
      className={`${classes.step} ${
        activeStep === 2 ? classes.active : classes.upcoming
      }`}
    >
      <span className={classes.badge}>2</span>
      {t("visa.auth.steps.verifyCard")}
    </span>
  </div>
);

export default VisaSteps;
